import React, { FC, Fragment, useContext, useEffect, useState } from 'react';

import { Button, CourseWrapper, FlexRowSpaceEvenly } from '../../common-styles/common-styles';
import { Course, Player, PlayerResult, TeamGameMatch, TeamGameMatchTeam, TeamGamePlayerDisplay } from '../../../../database.schema';

import { isLoggedIn } from '../../../app/authentication/auth';
import { SelectedIndexContext } from '../../../App';
import { useNavigate } from 'react-router-dom';
import { TierPoints6_6_6_ScoreCard } from './tier-points-666-score-card';
import { useFetchPlayers } from '../../../api/hooks/use-fetch-players';
import { TeamGameUpdateButton } from './team-game-update-button';
import { MATCH_FORMATS } from '../../../app/constants';
import { TierPoints1_2_3_ScoreCard } from './tier-points-123--score-card';
import { StablefordScoreCard } from './stableford-score-card';

export type Hole = {
  hole: number;
  par: number;
  strokeIndex: number;
  score: number;
  points: number;
};
type ScoreCardProps = {
  startingHole: number;
  tierPointsMatch: TeamGameMatch;
  course: Course;
  showScoreEntry: (value: boolean) => void;
  matchIndex: number;
  teamIndex: number;
};

export const TeamGameScoreCard: FC<ScoreCardProps> = ({ teamIndex, startingHole, tierPointsMatch, course, matchIndex }): JSX.Element => {
  const navigate = useNavigate();
  const [updateStatus, setUpdateStatus] = useState({ success: false, error: false });
  const { selectedTournamentIndex } = useContext(SelectedIndexContext);
  const [players, setPlayers] = useState<Array<TeamGamePlayerDisplay>>();

  const { data } = useFetchPlayers();
  useEffect(() => {
    if (data) {
      const players = data as Array<Player>;
      const team = tierPointsMatch;
      const playerDisplayData: Array<TeamGamePlayerDisplay> = [];
      team.teams[teamIndex].players.forEach((displayPlayer: PlayerResult) => {
        const playerName = players.find((player) => player.id === displayPlayer.playerId);
        if (playerName) {
          playerDisplayData.push({
            nickName: playerName.nickName,
            name: playerName.name,
            round: displayPlayer.round,
          });
        }
      });
      setPlayers(playerDisplayData);
    }
  }, [data]);

  if (players) {
    return (
      <Fragment>
        <h2>ScoreCard</h2>
        <CourseWrapper>Course: {course.name}</CourseWrapper>
        {updateStatus.error && <div>Update failed!!!!</div>}
        {tierPointsMatch.matchFormat === MATCH_FORMATS.tierPoints_6_6_6.id && (
          <TierPoints6_6_6_ScoreCard startingHole={startingHole} players={players} courseId={tierPointsMatch.courseId} />
        )}
        {tierPointsMatch.matchFormat === MATCH_FORMATS.tierPoints_1_2_3.id && (
          <TierPoints1_2_3_ScoreCard startingHole={startingHole} players={players} courseId={tierPointsMatch.courseId} />
        )}
        {tierPointsMatch.matchFormat === MATCH_FORMATS.stableford.id && <StablefordScoreCard startingHole={startingHole} players={players} courseId={tierPointsMatch.courseId} />}
        <FlexRowSpaceEvenly>
          {isLoggedIn() && (
            <TeamGameUpdateButton
              course={course}
              startingHole={startingHole}
              matchIndex={matchIndex}
              selectedTournamentIndex={selectedTournamentIndex}
              teamIndex={teamIndex}
              recordedMatchTeam={tierPointsMatch.teams[teamIndex]}
              setUpdateStatus={setUpdateStatus}
            />
          )}
          <Button onClick={() => navigate(`/team-game-edit-results/${selectedTournamentIndex}/${matchIndex}`)}>Back</Button>
        </FlexRowSpaceEvenly>
      </Fragment>
    );
  }

  return <div>Something went wrong no players found!</div>;
};
